import { FC } from "react"
import { SidebarHeaderProps } from "../types";

export const SidebarHeader : FC<SidebarHeaderProps> = ({children}) => {
    return (
        <>
            {children}
        </>
    );
};